import { render, staticRenderFns } from "./Bidding.vue?vue&type=template&id=8bcb42ba&scoped=true&"
import script from "./Bidding.vue?vue&type=script&lang=js&"
export * from "./Bidding.vue?vue&type=script&lang=js&"
import style0 from "./Bidding.vue?vue&type=style&index=0&id=8bcb42ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcb42ba",
  null
  
)

export default component.exports